 $(document).ready(function(){

    // Check apple device
    if (navigator.userAgent.indexOf('Mac OS X') != -1) {
        $("body").addClass("u-mac");
    }
    // Check apple device

    // Menu sidebar
    $('button.site-nav__link--iconNav').click(function(e){
        e.preventDefault();
        $('html').addClass('no-scroll');
        $('body').addClass('no-scroll c-open-sidebar');
        $('#shopify-section-custom-sidebar').addClass('c-active');
        $('.pageOverlay').addClass('c-active--sidebar');
        $('.site-header__search-container').removeClass('is-active');
    })
    
    $('.c-sidebar__closeBtn, .pageOverlay').click(function(e){
        e.preventDefault();
        $('html').removeClass('no-scroll');
        $('body').removeClass('no-scroll c-open-sidebar');
        $('#shopify-section-custom-sidebar').removeClass('c-active');
        $('.pageOverlay').removeClass('c-active');
        $('.pageOverlay').removeClass('c-active--sidebar');
        $('.site-header__search-container').removeClass('is-active');
    })

    $('.Collapsible__Button.u-h6').click(function(){
        $(this).next().slideToggle("slow");
        $(this).toggleClass("c-show");
    })
    // Menu sidebar


    // Menu tab 
    $('li.site-nav__item.site-nav__expanded-item.site-nav--has-dropdown.site-nav--is-megamenu').hover(function(){
        $('.pageOverlay').addClass('c-active');
    }, function(){
        $('.pageOverlay').removeClass('c-active');
    })
    // End menu tab 

    // Search 
    $('.site-nav__link--iconSearch').click(function(){
        $('html').toggleClass('no-scroll');
        $('body').toggleClass('no-scroll c-open-sidebar');
        $('.site-header__search-container').toggleClass('is-active');
        $('.pageOverlay').toggleClass('c-active');
        $('.pageOverlay').removeClass('c-active--sidebar');
    })
    // End Search 


    // Scroll Header Fix 
    headerFix();
    $(window).scroll(function(){
        headerFix();
        heightSlideshow();
        var winTop = $(window).scrollTop();
    });

    var temp = $(window).scrollTop();
    var headerHeight = 320;
    function headerFix(){
        var $windowTop = $(window).scrollTop();
        var $header = $('.header-section');

        if($(window).width() > 768){
            if($windowTop > 220){
                $header.addClass('js-pre-header-fix');
            }else{
                $header.removeClass('js-pre-header-fix');
            }
            
            if($windowTop > headerHeight){
                $header.addClass('js-header-fix');
            }else{
                $header.removeClass('js-header-fix');
            }
        }else{
            if($windowTop > 60){
                $header.addClass('js-pre-header-fix');
                $('.page-container').addClass('js-sticky');
            }else{
                $header.removeClass('js-pre-header-fix');
                $('.page-container').removeClass('js-sticky');
            }
            
            if($windowTop > 160){
                $header.addClass('js-header-fix');
            }else{
                $header.removeClass('js-header-fix');
            }
        }
    }
    // End Scroll Header Fix 

    // Height Slideshow 
    function heightSlideshow(){
       var $toolbarHeight = $('#shopify-section-toolbar').outerHeight();
       var $headerHeight = $('#shopify-section-header').outerHeight();
       var $menuTabsHeight = $('#shopify-section-menu-tabs').outerHeight();
       if($(window).width() < 769){
        //    $('.c-hero').outerHeight($(window).height() - $toolbarHeight - $headerHeight - $menuTabsHeight +15 );
        //    $('.c-hero').outerHeight($(window).height() - $toolbarHeight - $headerHeight - $menuTabsHeight - 41);
       }
   }
   heightSlideshow();
   // End Height Slideshow 
   
     // Fv slider 20240910～
    var $fvslideshow = $('.c-fv-slideshow__box');

    if ($fvslideshow.length) {
        $fvslideshow.slick({
          centerMode: true,
          centerPadding: "15%",
          infinite: true,
          arrows: true,
          dots: true,
          // fade: true,
          // cssEase: 'linear',
          // autoplay: true,
          // autoplaySpeed: 5000,
          // pauseOnFocus: false,
          // pauseOnHover: false,
          //appendArrows: '.c-fv-slideshow__arrow'
          prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0584/4438/2394/files/fv-arrow.svg?v=1725942714" class="c-fv-slide-arrow prev-arrow">',
    nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0584/4438/2394/files/fv-arrow.svg?v=1725942714" class="c-fv-slide-arrow next-arrow">',
          dotsClass: "c-fv-slide-dots",
          responsive: [
      {
        breakpoint: 769,
        settings: {
          centerPadding: "0%",
          arrows: false,
        },
      },
    ],
        });
    }
    // End Fv slider


     // News slider
    var $slideshow = $('.c-new-slideshow__box');
    var $timelineBox = $('.c-new-slideshow__countBox');

    if ($slideshow.length) {
        var currentSlide;
        var slidesCount;
        var sliderCounter = $('.c-new-slideshow__counter');

        var updateSliderCounter = function updateSliderCounter(slick, currentIndex) {
            currentSlide = slick.slickCurrentSlide() + 1;
            slidesCount = slick.slideCount;

            if (slidesCount <= 9) {
                // $(sliderCounter).text(currentSlide + '/' +slidesCount)
                $(sliderCounter).html("<span class='c-slideshow__current'>" + currentSlide + "</span><span class='c-slideshow__total'>" + slidesCount + "</span>");
            } else {
                // $(sliderCounter).text(currentSlide + '/' +slidesCount)
                $(sliderCounter).html("<span class='c-slideshow__current'>" + currentSlide + "</span><span class='c-slideshow__total'>" + slidesCount + "</span>");
            }
        };

        $slideshow.on('init', function (event, slick) {
            $timelineBox.append(sliderCounter);
            updateSliderCounter(slick);
        });

        $slideshow.on('afterChange', function (event, slick, currentSlide) {
            updateSliderCounter(slick, currentSlide);
        });

        $slideshow.slick({
            slidesToShow: 1,
            infinite: true,
            arrows: true,
            dots: false,
            // fade: true,
            // cssEase: 'linear',
            // autoplay: true,
            // autoplaySpeed: 5000,
            // pauseOnFocus: false,
            // pauseOnHover: false,
            appendArrows: '.c-new-slideshow__arrow'
        });
    }
    // End News slider


    // Check japanese character
    $(".header-item--sticky .site-nav__item .site-nav__link").each(function(){
        var foreignCharacters = $(this).text();
        var rforeign = /[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf]/;

        if (rforeign.test(foreignCharacters)) {
        var $jpText = '<span class="u-jpText">'+ foreignCharacters +'</span>';
        $(this).html($jpText);
        }
    })
    // End Check japanese character

    $(".contact-form").attr("autocomplete", "off");
     $('.js-Guide li a').click(function(e){
       e.preventDefault();
       let objId = $(this).attr('href');
       let $id = $(objId);
       if ($id.length === 0) { 
         return;
       }
       $('html, body').animate({
         scrollTop: $id.offset().top - 90
       }, 500);
     });

     // height sections  slider home
       function fixHeightSlider(){
         var heightContent = $('.hero__sidebyside-content').outerHeight();
         var heightImage = $('.hero__sidebyside-image').outerHeight();
         var outHeight = heightContent + heightImage;
         $('.c-hero').height(outHeight);
       }

       fixHeightSlider();
//      $( window ).resize(function() {
//        if($( window ).width() < 769 ){
//          fixHeightSlider();
//        }
//      });

   	// End height sections  slider home
   if($( window ).width() > 768 ){
     $('.js-brandVendor').on('click', function(){
       $(this).toggleClass('is-open').parent().find('.collapsible-content').slideToggle('medium');
     });
   }
   $('.collection-filter__btn--show').click(function(){
   	$('.collection-sidebar__group').addClass('filter-mobile')
   });
   $('.collection-sidebar__group-toolbar-top').click(function(){
     $('.collection-sidebar__group').removeClass('filter-mobile')
   });
   
   $( "#create_customer" ).submit(function( event ) {
     event.preventDefault();
     if($('#checkbox-newsletter').is(":checked")){
       $('.form-checkboxNewsletter').append('<input type="hidden" name="customer[accepts_marketing]" value="true" id="marketing" />')
       return true;
     }
     else{
       return false;
     }
   });
 })
